import { Wrapper } from '@american-autonomy/ag-ui';

import Card from 'components/Card';

import ActivityCardHeader from './components/ActivityCardHeader';
import ActivityCardItems from './components/ActivityCardItems';
import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ActivityCard: FunctionComponent<Props> = ({
    className = '',
    date,
    items = [],
    testId = TEST_ID
}) => {
    const dateToCheck = new Date(date).setHours(0, 0, 0, 0);
    const today = new Date().setHours(0, 0, 0, 0);
    const isToday = dateToCheck === today;

    const headerBorderStyle = isToday ? styles.todayHeader : styles.dayOfWeekHeader;

    const emptyItems = [<Wrapper className={styles.cardItem} key={0} />];

    if (items.length === 0) {
        emptyItems.push(<Wrapper className={styles.cardItem} key={1} />);
    }

    return (
        <Card className={`${className} ${styles.activityCard}`} testId={testId}>
            <Wrapper className={`${styles.activityCardHeaderWrapper} ${headerBorderStyle}`}>
                <ActivityCardHeader className={styles.activityCardHeader} date={date} />
            </Wrapper>

            <ActivityCardItems className={styles.activityCardItems} items={items} />

            {emptyItems}
        </Card>
    );
};

export default ActivityCard;
